import { channelMembersDescription as description } from './description';
import { members as execute } from './execute';

export { description, execute };
